/**
 * i18n-Bootstrap für nest.amzel.io.
 *
 * Default = English. Auswahl wird via Cookie auf `.amzel.io` persistiert
 * (cross-subdomain), sodass nest.amzel.io und app.amzel.io dieselbe
 * Sprache teilen. Zusaetzlich localStorage als Fallback fuer lokale
 * Dev-Setups ohne `.amzel.io`-Host.
 *
 * Side-effect-Import: `import "./i18n"` reicht — initialisiert i18next
 * synchron mit allen Locale-Resources gebundled (kein async-Load).
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pl from "./locales/pl.json";
import { readStoredLang, writeStoredLang } from "./lang-storage";

export { SUPPORTED_LANGS, type LangCode } from "./lang-storage";

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    pl: { translation: pl },
    fr: { translation: fr },
    it: { translation: it },
  },
  lng: readStoredLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

if (typeof window !== "undefined") {
  document.documentElement.lang = i18n.language;
  i18n.on("languageChanged", (lng) => {
    writeStoredLang(lng);
    document.documentElement.lang = lng;
  });
}

export default i18n;
